// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wPCL","content":"styles_content__3WPLv"};